function resolveComponentType(factory, type) {
  return factory.resolve(type);
}
function resolveComponentFlags(factory, type) {
  return factory.resolveFlags(type);
}
export {
  resolveComponentFlags,
  resolveComponentType
};
//# sourceMappingURL=utilities.js.map
